import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { MY_TEAM_LEAGUES_QUERY_KEY, RECOMMENDED_LEAGUES_QUERY_KEY } from '@/hooks/constants';
import { addLeagueToFavorite, removeLeagueFromFavorite } from '@/services/actions/league/leagueFavorites';

export const useFavoriteLeagueMutation = () => {
	const queryClient = useQueryClient();

	const addToFavorites = useMutation({
		mutationFn: async (data: { moduleUuid: string }) => {
			const response = await addLeagueToFavorite(data);
			if (response.error) {
				throw new Error(response.error);
			}
			return response;
		},
		onSuccess: (_data) => {
			queryClient.invalidateQueries({ queryKey: [RECOMMENDED_LEAGUES_QUERY_KEY] });
			queryClient.invalidateQueries({ queryKey: [MY_TEAM_LEAGUES_QUERY_KEY] });
		},
		onError: () => {
			toast.error('Failed to add league to favorites. Please try again.');
		}
	});

	const removeFromFavorites = useMutation({
		mutationFn: async (data: { moduleUuid: string }) => {
			const response = await removeLeagueFromFavorite(data);
			if (response.error) {
				throw new Error(response.error);
			}
			return response;
		},
		onSuccess: (_data) => {
			queryClient.invalidateQueries({ queryKey: [RECOMMENDED_LEAGUES_QUERY_KEY] });
			queryClient.invalidateQueries({ queryKey: [MY_TEAM_LEAGUES_QUERY_KEY] });
		},
		onError: () => {
			toast.error('Failed to remove league from favorites. Please try again.');
		}
	});

	return { addToFavorites, removeFromFavorites, isAdding: addToFavorites.isPending, isRemoving: removeFromFavorites.isPending };
};
